import React, {useContext} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import LookWizardContext from "./lookWizardContext";


const LookWizardContentTitle = (props) => {

  const {wizardActiveItem, wizardActiveStep} = props;

  const {currentGroups} = useContext(LookWizardContext);

  if (wizardActiveStep === -1) {
    // return <FormattedMessage id="wizard.step.selectTitle" values={{wizardName: wizardActiveItem.name}}/>
    return wizardActiveItem.name
  }
  if (wizardActiveStep > -1 && currentGroups.length === 1) {
    return currentGroups[0].title
  }
  if (wizardActiveStep > -1 && !currentGroups.length) {
    return <FormattedMessage id="wizard.completed.title" values={{wizardName: wizardActiveItem.name}}/>
  }
  if (wizardActiveStep === 0 && currentGroups.length > 1 && wizardActiveItem.startTitle) {
    return wizardActiveItem.startTitle
  }
  return null
};

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep} = store.wizardState;
  return {
    wizardActiveItem,
    wizardActiveStep,
  };
};

export default connect(mapStateToProps)(LookWizardContentTitle)
